import React, { memo } from 'react';
import PropTypes from 'prop-types';

import ItemList from 'components/Shared/User/ItemList';
import { member as Item } from 'components/Shared/User/Item/container';
import isEqual from 'react-fast-compare';

const MemberItemList = ({
    size,
    _feed,
    actionRender,
    displayPendingBadge,
    fallbackMessage,
    isLoading,
    _users
}) => (
    <ItemList
        ids={_users}
        fallbackMessage={fallbackMessage}
        isLoading={isLoading}
        itemRender={(_user) => (
            <Item
                key={_user}
                _user={_user}
                avatarSize="default"
                size={size}
                context="member"
                _feed={_feed}
                actionRender={actionRender}
                displayPendingBadge={displayPendingBadge}
                noStatus={false}
            />
        )}
    />
);

MemberItemList.propTypes = {
    _users: PropTypes.arrayOf(PropTypes.string),
    fallbackMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    displayPendingBadge: PropTypes.bool,
    size: PropTypes.oneOf(['', 'xs']),
    isLoading: PropTypes.bool,
    _feed: PropTypes.string,
    actionRender: PropTypes.func
};

export default memo(MemberItemList, isEqual);
